import { DeliveryStatus, LocalizedString } from '@synergy/models';
import { PaloPreviewImage } from '@synergy/components-palo';

type CurrencyPrice = Record<string, number>;

/** An article the member ordered, with its last order (#2280). */
export interface OrderedArticle {
    product: {
        id: number;
        number?: string;
        globalTradeItemNumber?: string;
        name: LocalizedString;
        orderUnit: LocalizedString;
        previewImage?: PaloPreviewImage;
        minimumOrderQuantity?: number;
        deliveryStatus?: DeliveryStatus;
        deliveryTimeInDays?: number;
        supplier?: { id: number; name: string };
        mainPrice: CurrencyPrice;
        currentSpecialPrice?: CurrencyPrice | null;
    };
    orderCount: number;
    lastOrderDate?: string;
    lastQuantity?: number;
    lastNetPrice?: number;
    lastOrderer?: string;
    lastDeliveryCity?: string;
    /** Whether the cart takes it today; the delivery status alone does not say. */
    isAvailableForPurchase: boolean;
}

/** What one piece costs today, special price first, as the shop shows it. */
export const todaysUnitPrice = (article: OrderedArticle, currency: string): number | undefined =>
    article.product.currentSpecialPrice?.[currency] ?? article.product.mainPrice[currency];
